import React, { Component } from 'react';
import Modal from 'react-modal';
import QRCodeGenerator from 'qrcode-generator';

Modal.setAppElement('body');

export default class QrCodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      qrCodeValue: '',
      title: '',
      qrScale: this.getScale(),
    };

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    this.setState({ qrScale: this.getScale() });
  }

  getScale() {
    const width = window.innerWidth;

    if (width <= 400) return 4; // celular
    if (width <= 768) return 6; // tablet
    if (width <= 1200) return 10; // notebook
    if (width <= 1920) return 16; // Full HD
    return 20; // telas 4K ou projetores grandes
  }

  open(value, title) {
    this.setState({ isOpen: true, qrCodeValue: value, title: title });
  }

  close() {
    this.setState({ isOpen: false, qrCodeValue: '', title: '' });
  }

  generateQRCodeHTML(value, scale) {
    const qr = QRCodeGenerator(0, 'L');
    qr.addData(value);
    qr.make();
    return qr.createImgTag(scale);
  }

  render() {
    const { isOpen, qrCodeValue, title, qrScale } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={this.close.bind(this)}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 9999,
          },
          content: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            margin: 0,
            border: 'none',
            backgroundColor: 'black',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
          },
        }}
        contentLabel="QR Code Modal"
      >
        <button
          onClick={this.close.bind(this)}
          style={{
            position: 'absolute',
            top: 20,
            right: 30,
            padding: '10px 20px',
            fontSize: '1.2rem',
            cursor: 'pointer',
            border: 'none',
            borderRadius: '8px',
            backgroundColor: '#fff',
            color: '#000',
            fontWeight: 'bold',
          }}
        >
          Fechar ✕
        </button>

        <div style={{ textAlign: 'center' }}>
          <h2 style={{ marginBottom: '40px', fontSize: '2rem' }}>{title}</h2>
          {qrCodeValue && (
            <div
              dangerouslySetInnerHTML={{
                __html: this.generateQRCodeHTML(qrCodeValue, qrScale),
              }}
              style={{
                display: 'inline-block',
                maxWidth: '90vw',
                maxHeight: '80vh',
              }}
            />
          )}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/QrCodeModal.js